import React from "react";

// components
import { GroupCollapsibleCard } from "./Common";

const GroupTab = ({ details }: any) => {
  const ALLOWANCE_TYPE: any = {
    AMOUNT: "정액제",
    RATE: "정률제",
  };

  const ALLOWANCE_BASE_TYPE: any = {
    SALESPRICE: "판매금액 기준",
    PAYMENTAMOUNT: "결제금액 기준",
  };

  const ALLOWANCE_VAT_YN: any = {
    Y: "부가세 포함 후 정산",
    N: "부가세 제외 후 정산",
  };

  const CLASS_ATTENDANCE_TYPE: any = {
    ALL: "모든 출석과 결석",
    ABSENT: "출석과 차감결석",
    ATTENDANCE: "출석",
  };

  return (
    <div className="tab-content">
      <span className="tab-title">그룹수업 수당</span>

      <div className="section">
        <span>수당 지급 방식</span>
        <span>{details?.allowanceType ? ALLOWANCE_TYPE[details?.allowanceType] : "미설정"}</span>
      </div>

      <div className="section">
        <span>수당 대상 금액 기준</span>
        <span>
          {details?.allowanceBaseType ? ALLOWANCE_BASE_TYPE[details?.allowanceBaseType] : "미설정"}
        </span>
      </div>

      <div className="section">
        <span>부가세 포함여부</span>
        <span>
          {details?.allowanceVatYn ? ALLOWANCE_VAT_YN[details?.allowanceVatYn] : "미설정"}
        </span>
      </div>

      <div className="section">
        <span>수업 참석자 기준</span>
        <span>
          {details?.classAttendanceType
            ? CLASS_ATTENDANCE_TYPE[details?.classAttendanceType]
            : "미설정"}
        </span>
      </div>

      <div className="table-title with-count">
        수당 설정 수업
        <span>{details?.partnerLessons ? `${details?.partnerLessons?.length}건` : "미설정"}</span>
      </div>

      {details?.partnerLessons?.map((lesson: any, index: number) => {
        return (
          <GroupCollapsibleCard
            key={index}
            lesson={lesson}
            allowanceType={details?.allowanceType}
          />
        );
      })}
    </div>
  );
};

export default GroupTab;
